<template>
  <div>
    <b-modal
      centered
      id="ModalNewImportAuditorConnect"
      size="lg"
      modal-class="custom-dialog dialog-800"
      hide-footer
      :title="'Nueva tarifa'"
      @close="close"
      no-close-on-esc
      no-close-on-backdrop
    >
      <ul class="modal-msj">
        <li>Por favor, proporcione detalles específicos sobre la nueva tarifa que desea crear.</li>
      </ul>
      <template>
        <form-render :form="form" :fields="fields" ref="formImportAuditorConnect">
          <template #labelFieldFile>
            <div class="mt-1 p-0 label-field-file">
              <span class="m-0 p-0">
                Subir archivos de Tarifa (
                <a
                  :href="form.country ? url : 'javascript:void(0)'"
                  :class="{ 'disabled-link': !form.country }"
                  :tabindex="form.country ? 0 : -1"
                  target="_blank"
                >
                  Descargar Formato
                </a>
                )
              </span>
            </div>
          </template>
        </form-render>
        <div class="footer-modal-coverage">
          <b-button class="float-right mt-1 mb-1" variant="outline-success" @click="ok" :disabled="loading.createTariff || disabledButton">
            <span v-if="!loading.createTariff" class="mb-1">Crear Tarifa</span>
            <span class="mt-1 p-2" v-if="loading.createTariff"><b-spinner small /> </span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseServices from '@/store/services/index'
import dayjs from 'dayjs'

export default {
  name: 'ModalNewImportAuditorConnect',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      carriers: 'getCarriersOriginsModal',
      services: 'getServicesByCountryCarrier',
      generalLoading: 'getLoading'
    })
  },
  watch: {
    carriers() {
      this.setOptions('carriers', 'carrier')
      const resetFields = ['carrier', 'service']
      resetFields.forEach(el =>  this.m_setSkeletonField(this.fields, 'name', el, false))
    },
    services() {
      this.setOptions('services', 'service')
      this.m_setSkeletonField(this.fields, 'name', 'service', false)
    },
    generalLoading: {
      handler() {
        this.loading.countries = !!this.generalLoading.getCountriesCoverage
        this.loading.carriers = !!this.generalLoading.getCarriersOriginsModal
      },
      deep: true
    }
  },
  data() {
    return {
      baseService: new BaseServices(this),
      form: {},
      fields: [],
      url: '',
      loading: {
        createTariff: false
      },
      disabledButton: false
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'carrier', label: 'Courier', containerClass: 'col-6', change: this.changeCarriers, dependency: `${this.m_isAdmin() ? 'country' : ''}`, sort: true, validation: 'required' },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'service', label: 'Servicio', containerClass: 'col-6', dependency: 'carrier', sort: true, validation: 'required' },
        { name: 'labelFieldFile', useSlot: true, containerClass: 'col-12' },
        { fieldType: 'FieldFileDropArea', name: 'FileTariffs', labelFormFile: 'Subir Tarifa', containerClass: 'col-12 container-info', accept: '.xls, .xlsx', classField: 'hide-button-browse', clearable: true, validation: 'required' }
      ]
      if (this.m_isAdmin()) {
        this.fields.unshift(
          { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'country', disabled: false, label: 'País', containerClass: 'col-6 fieldSelect', change: this.changeCountry, addFlags: true, validation: 'required', sort: true, options: this.data.countries },
          { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'idSeller', type: 'text', label: 'ID Usuario', containerClass: 'col-6 fieldSelect', dependency: 'country', clearable: true, change: this.changeIdSeller, searchOnType: { fx: this.setSeller, nChars: 2, debounce: 600, allowSearchAsValue: false, persistSearch: true }, validation: 'required' }
        )
      } else {
        this.form.country = this.$session.get('cas_user').country
        this.setURL()
      }
    },
    setOptions(name, fieldName) {
      this.fields[this.m_getElementIndex(this.fields, 'name', fieldName)].options = this[name].rows
    },
    setURL() {
      const countryCode = this.form.country?.code
      const urls = {
        CL: 'https://storage.googleapis.com/formato-archivos-subida-akatsuki/connect-rates/FormatoCargaDeTarifasConnectChile.xlsx',
        CO: 'https://storage.googleapis.com/formato-archivos-subida-akatsuki/connect-rates/FormatoCargaDeTarifasConnectColombia.xlsx',
        PE: 'https://storage.googleapis.com/formato-archivos-subida-akatsuki/connect-rates/FormatoSubidaDeTarifasConnectPeru.xlsx',
        MX: 'https://storage.googleapis.com/formato-archivos-subida-akatsuki/connect-rates/FormatoCargaDeTarifasConnectMexico.xlsx'
      }
      this.url = urls[countryCode] || ''
    },
    async setSeller(value) {
      const params = { country_id: this.form.country.id }
      const queryParams = { search: value, include_shippers: true }
      try {
        const resp = await this.baseService.callService('getSeller', queryParams, params)
        return resp.data.organizations.map(el => ({ ...el, text: el.fullname, valid: true }))
      } catch (err) {
        return err
      }
    },
    changeCountry(name, value) {
      if (value) {
        this.m_setSkeletonField(this.fields, 'name', 'carrier', true)
        this.$store.dispatch('fetchService', { name: 'getCarriersOriginsModal', params: { country_id: value.id } })
        this.changeCarriers('carrier', null)
      }
      this.showTable = false
      this.setURL()
    },
    changeCarriers(name, value) {
      if (value) {
        const params = { country_id: this.form.country.id, carrier_id: value.id }
        this.m_setSkeletonField(this.fields, 'name', 'service', true)
        this.$store.dispatch('fetchService', { name: 'getServicesByCountryCarrier', params })
      } else {
        delete this.form.carrier
      }
      delete this.form.service
      this.showTable = false
    },
    async ok(e) {
      this.disabledButton = true
      e.preventDefault()
      const check = await this.$refs.formImportAuditorConnect.onlyCheckForm()
      if (check) {
        this.sendData()
      } else {
        this.disabledButton = false
      }
    },
    getParams(service = 'getValidationAuditorConnect') {
      const params = {
        country_code: this.form.country.code,
        country_id: this.form.country.id,
        carrier_id: this.form.carrier.id,
        carrier_service_id: this.form.service.id
      }
      if (this.form.idSeller) params.company_id = this.form.idSeller.id
      if (service === 'postConnectRates') {
        params.validity_date = dayjs(new Date).format('YYYY-MM-DD')
        params.update_now = true
        params.file = this.form.FileTariffs
      }
      return params
    },
    sendData() {
      this.baseService.callService('getValidationAuditorConnect', this.getParams('getValidationAuditorConnect'))
        .then(response => {
          if (response.data.length) {
            this.showAlert(response.data)
          } else {
            this.createTariff()
          }
        })
        .catch(error => {
          this.$newError('Error al validar tarifas', error, 'large')
        })
        .finally(() => {
          this.disabledButton = false
        })
    },
    showAlert(data) {
      const title = 'Tarifas existentes'
      const carrierNames = data.map(el => el.carrier_name).join(', ')
      const msg = `
        <div>
          <div>
            Hemos detectado tarifas de <b>${carrierNames}</b> cargadas previamente.
          </div>
          <div>
            ¿Qué desea hacer para las tarifas coincidentes?
          </div>
        </div>
      `
      this.$confirm(msg, () => this.createTariff(), title, 'Crear nueva versión', 'Descartar cambios')
    },
    createTariff() {
      this.loading.createTariff = true
      this.baseService.callUploadFileCustomParams('postConnectRates', this.getParams('postConnectRates'))
        .then(() => {
          this.$newSuccess('En proceso', 'La tarifa connect está siendo importada. Será notificado via email cuando el proceso haya finalizado.', 'large')
        })
        .catch(error => {
          this.$newError('Error al crear tarifa', error.message, 'large')
        })
        .finally(() => {
          this.loading.createTariff = false
          this.close()
        })
    },
    close() {
      this.$emit('closeModal', 'ModalNewImportAuditorConnect')
    }
  }
}
</script>

<style lang="css">
.label-field-file {
  font-size: inherit;
}
.disabled-link {
  pointer-events: none;
  color: #aaa; /* Estilo visual para indicar que está deshabilitado */
  text-decoration: none;
}
</style>